// @ts-nocheck

const getSelectedVariantQuantity = (selectedVariants = [], variants = []) => {
  if (!Array.isArray(selectedVariants) || selectedVariants.length === 0) {
    return 0;
  }

  const selectedIds = new Set(
    selectedVariants
      .map((v) => String(v?.id ?? v?.tempId ?? ''))
      .filter(Boolean),
  );

  return (variants || []).reduce((sum, variant) => {
    const variantId = String(variant?.id ?? variant?.tempId ?? '');
    if (!variantId || !selectedIds.has(variantId)) return sum;
    return sum + (Number.parseFloat(variant?.quantity) || 0);
  }, 0);
};

export const getDecorationExtSellValue = (decoration, variants = []) => {
  if (decoration?.hideSell) return 0;

  const price = Number.parseFloat(decoration?.price ?? 0);
  if (!Number.isFinite(price)) return 0;

  const selectedVariantQuantity = getSelectedVariantQuantity(
    decoration?.variant,
    variants,
  );

  return price * selectedVariantQuantity;
};
